import cn from "classnames"

import { Flex, Link, Text } from "@/atoms"
import { capitalizeFirstLetter } from "@/helpers/string.helpers"
import { useTranslation } from "@/hooks/useTranslation"

import styles from "./FunnelCard.module.scss"

import type { RuntimeLowCoverageTeaserProps } from "."

export const RuntimeLowCoverageTeaser = (
  props: RuntimeLowCoverageTeaserProps
) => {
  const { t } = useTranslation()
  const { t: tRuntimeLowCoverage } = useTranslation("translation", {
    keyPrefix: "funnel.runtimeLowCoverage"
  })
  const textInLink = `${props.runtimeCount} ${capitalizeFirstLetter(t("general.issue", { count: props.runtimeCount }))}`

  return (
    <Flex
      vertical
      align="center"
      gap={9}
      className={cn(styles.runtimeTeasers, styles.runtimeTeasersLowCoverage)}
    >
      <Text className={cn("sm-text-ks", "capitalize-text-ks")}>
        {tRuntimeLowCoverage("title")}
      </Text>
      {!!props.runtimeCount && (
        <Link to={props.to} className={cn(styles.textNormal, styles.link)}>
          {tRuntimeLowCoverage("link", { text: textInLink })}
        </Link>
      )}
    </Flex>
  )
}
